import styled from 'styled-components';
export const CardContainer = styled.div `
  padding: var(--spacing-size-2xs);
  background-color: var(--color-contrast-white);
  border-radius: var(--border-radius-md);
  margin-top: var(--spacing-size-3xs);
  display: flex;

  :first-child {
    margin-top: 0 !important;
  }

  .end {
    align-items: end;
  }

  .center {
    align-items: center;
  }

  .column {
    width: 100%;
    display: flex;

    .tag {
      margin-right: var(--spacing-size-xs);
    }
  }

  button.close_btn {
    padding: 0;
    border: none;
    background-color: transparent;
    border-radius: var(--border-radius-sm);
    margin-left: var(--spacing-size-xs);
    cursor: pointer;

    img {
      width: 24px;
      height: 24px;
    }
  }

  .tooltip {
    position: relative;
    display: inline-block;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    background-color: var(--color-neutral-400);
    color: var(--color-contrast-white) !important;
    text-align: center;
    padding: 10px 6px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    width: 120px;
    top: 100%;
    left: 50%;
    margin-left: -60px;
    font-weight: normal !important;
    font-size: var(--font-size-xs);
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }
`;
export const CardTitle = styled.div `
  font-weight: var(--font-weight-semibold);
`;
export const CardInfo = styled.div `
  margin-top: var(--spacing-size-3xs);
  font-size: var(--font-size-xs);
  color: var(--color-neutral-400) !important;
  line-height: var(--line-height-lg);
`;
export const ButtonAction = styled.button `
  background-color: transparent;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 48px;
  height: 48px;

  label {
    margin-right: 10px;
    cursor: pointer;
  }

  &:hover {
    background-color: var(--color-feedback-warning-200);
    border-radius: var(--border-radius-default);
  }
`;
export const AlignCenter = styled.div `
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
`;
//# sourceMappingURL=style.js.map